import { FC, createContext, useEffect, useState } from "react";
import {
  PhysicalExaminationContextType,
  PhysicalExaminationListType,
} from "./types";
import PhysicalExaminationList from "./PhysicalExaminationList";
import PhysicalExaminationRos from "./PhysicalExaminationRos";
export const PhysicalExaminationContext =
  createContext<PhysicalExaminationContextType>({
    list: [],
    setList: () => { },
    edit: null,
    setEdit: () => { },
    refetch: true,
    setRefetch: () => { },
    refetchRos: true,
    setRefetchRos: () => { }
  });
const PhysicalExamination: FC<{ component?: "ROS" | "Examination" }> = ({ component }) => {
  const [list, setList] = useState<PhysicalExaminationListType[]>([]);
  const [edit, setEdit] = useState<PhysicalExaminationListType | null>(null);
  const [refetch, setRefetch] = useState<boolean>(true)
  const [refetchRos, setRefetchRos] = useState<boolean>(true)
  useEffect(() => {
    return () => {
      setList([]);
      setEdit(null);
    };
  }, []);
  return (
    <PhysicalExaminationContext.Provider
      value={{ list, setList, edit, setEdit, refetch, setRefetch, refetchRos, setRefetchRos }}>
      <div className="flex flex-col gap-3">
        {
          Boolean(component) ? (<>
            {component == "ROS" && <PhysicalExaminationRos />}
            {component == "Examination" && <PhysicalExaminationList />}
          </>) : (<>
            <PhysicalExaminationList />
            <PhysicalExaminationRos />
          </>)
        }
      </div>
    </PhysicalExaminationContext.Provider>
  );
};

export default PhysicalExamination;
